

































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import AddPurchaseDiscountTrigger from './AddPurchaseDiscountTrigger.coffee'

settings =
  name: 'AddPurchaseDiscountTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [AddPurchaseDiscountTrigger.trigger()]

    computed:
      discount: -> @modal?.data?.discount || {}
      discountType: -> @discount.type

    methods:
      modalData: -> {
        discount: {
          discount_in_dollars: null,
          discount_percentage: null,
          type: 'dollar'
        }
      }
    watch:
      discountType: (type) ->
        if 'dollar' is type
          @discount.discount_percentage = null
        else
          @discount.discount_in_dollars = null

export default VueOptions.vue settings
